export function formatCurrency(value, currency = 'USD', locale) {
  const resolvedLocale =
    locale ||
    (typeof document !== 'undefined' ? document.documentElement.lang : '') ||
    'en';

  const amount = Number(value || 0);

  try {
    return new Intl.NumberFormat(resolvedLocale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch (error) {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function classNames(...values) {
  return values.filter(Boolean).join(' ');
}

export function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl, window.location.origin);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.delete(key);

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== '') {
          url.searchParams.append(key, item);
        }
      });

      return;
    }

    if (value !== '' && value !== null && value !== undefined) {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
}
